import {
    SET_ACCEPTED_HARD_CHECK,
    SET_DO_HARD_CHECK_FULFILLED,
    SET_DO_HARD_CHECK_PENDING,
} from '../../../constants/ActionTypes';
import underWrittingSummaryInitialState from './underWrittingSummaryInitialState';

function underWrittingSummaryReducer(state = underWrittingSummaryInitialState, action) {
    switch (action.type) {
    case SET_ACCEPTED_HARD_CHECK:
        return {
            ...state,
            acceptedHardCheck: action.acceptedHardCheck,
        };
    case SET_DO_HARD_CHECK_PENDING:
        return {
            ...state,
            isPending: true,
            hardCheckCompleted: false,
        };
    case SET_DO_HARD_CHECK_FULFILLED:
        return {
            ...state,
            isPending: false,
            hardCheckCompleted: true,
        };
    default:
        return state;
    }
}

export default underWrittingSummaryReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/underWrittingSummaryReducer.js